export default {"src":"/_next/static/media/logo_small_white.dddb8661.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};